"use client"
import React from 'react'
import { useEffect, useState } from "react";
import BannerSectionMarqueeVertical from './BannerSectionMarqueeVertical'
import ImageHoverVideo from '@/app/components/ImageHoverVideo'
import { motion, AnimatePresence } from "motion/react"
import { BlurFade } from './BlurFade'
// import ShinyButton from './ShinyButton'
/////import { redirect } from 'next/dist/server/api-utils'

//import { countDown } from '@/app/utils/CountDown'

import { BoxReveal } from './BoxReveal';
import { BorderBeam } from './BorderBeam'
import { homeDict, type HomeBannerDict } from '@/lib/i18n/dicts/home'

// 中文文件名必须编码，否则 SSR 预加载进入 HTTP Link 响应头时会触发 ByteString 报错
const enc = (u: string) => encodeURI(u)


//const TryGameTime = 3



export const showcase =
{
    thumbnail: '/img/gamepic/14.Ludo1.png',
    video: '/img/gamepic/1Ludo.mp4',
    description: '',
}


const Section00 = () => {
    return (
        <>
            <div className="w-full  lg:absolute top-0 hidden lg:block right-0 bottom-0 mt-0 mr-4 overflow-hidden  min-w-[1280px]" id="screen0">

                {/* <BannerSectionMarqueeVertical /> */}

                {/* <img src='/img/Banner/top-banner-11.jpg' /> */}
                {/* <div
    aria-hidden="true"
    className="pointer-events-none lg:absolute lg:inset-y-0 lg:max-w-7xl lg:mx-auto lg:w-full "
>
    <div className="absolute transform sm:left-1/2 sm:top-0 sm:translate-x-8 lg:left-1/2 lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-8">
        <div className="flex items-center space-x-6 lg:space-x-8">
            <BannerSectionMarqueeVertical />
        </div>
    </div>
</div> */}
                <AnimatePresence mode="wait">
                    {/* <motion.div
        initial={{ rotate: 0 }}
        animate={{ rotate: 360 }}
        transition={{ duration: 1 }}

    > */}
                    {/* 方案1 begin */}
                    <div
                        aria-hidden="true"
                        className="pointer-events-none absolute inset-y-0 max-w-7xl mx-auto w-full min-w-[1280px]"
                    >
                        <div className="absolute transform sm:left-1/2 sm:top-0 sm:translate-x-8 lg:left-1/2 lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-8">
                            <div className="flex items-center space-x-6 lg:space-x-8">
                                <div className="flex-shrink-0 grid grid-cols-1 gap-y-4 lg:gap-y-4">
                                    <div className="animate-blur-fade-in" style={{ animationDelay: '0s' }}>
                                        <div className=" w-44  h-64 rounded-lg overflow-hidden sm:opacity-0 lg:opacity-100">
                                            <img
                                                src="/img/Banner/1/13.png"
                                                alt=""
                                                className="w-full h-full object-center object-cover"
                                            />
                                        </div>
                                    </div>
                                    <div className="animate-blur-fade-in" style={{ animationDelay: '0.06s' }}>
                                        <div className="w-44 h-64 rounded-lg overflow-hidden">
                                            <img
                                                src="/img/Banner/1/10-2.png"
                                                alt=""
                                                className="w-full h-full object-center object-cover"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-shrink-0 grid grid-cols-1 gap-y-4 lg:gap-y-4">
                                    <div className="animate-blur-fade-in" style={{ animationDelay: '0.12s' }}>
                                        <div className="w-44 h-96 rounded-lg overflow-hidden">
                                            <img
                                                src="/img/Banner/1/14.png"
                                                alt=""
                                                className="w-full h-full object-center object-cover"
                                            />
                                        </div>
                                    </div>
                                    {/* <BlurFade delay={0.06 * 3} inView>
                                        <div className="w-44 h-72 rounded-lg overflow-hidden">
                                            <img
                                                src="/img/gamepic/14.Ludo4.png"
                                                alt=""
                                                className="w-full h-full object-center object-cover"
                                            />

                                            
                                        </div>
                                    </BlurFade> */}
                                    {/* <ul><ImageHoverVideo key={1} site={showcase} priority={1 < 6} /></ul> */}
                                    {/* <BlurFade delay={0.06 * 4} inView>
                                        <div className="w-44 h-72 rounded-lg overflow-hidden">
                                            <img
                                                src="/img/gamepic/14.Ludo1.png"
                                                alt=""
                                                className="w-full h-full object-center object-cover"
                                            />
                                        </div>
                                    </BlurFade> */}
                                </div>
                                <div className="flex-shrink-0 grid grid-cols-1 gap-y-4 lg:gap-y-4">
                                    <div className="animate-blur-fade-in" style={{ animationDelay: '0.3s' }}>
                                        <div className="w-44 h-64  rounded-lg overflow-hidden">
                                            <img
                                                src="/img/Banner/1/12.png"
                                                alt=""
                                                className="w-full h-full object-center object-cover"
                                            />
                                        </div>
                                    </div>
                                    <div className="animate-blur-fade-in" style={{ animationDelay: '0.36s' }}>
                                        <div className="w-44 h-64 rounded-lg overflow-hidden">
                                            <img
                                                src="/img/Banner/1/11.png"
                                                alt=""
                                                className="w-full h-full object-center object-cover"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* 方案1 end  */}

                    {/* </motion.div> */}
                </AnimatePresence>
            </div>
        </>
    )
}

const Section01 = () => {
    return (
        <>
            {/* style={{ display: "none" }} */}
            <div className="w-full  lg:absolute top-0 hidden lg:block right-0 bottom-0 mt-0 mr-4 overflow-hidden  " id="screen1" >
                <div
                    aria-hidden="true"
                    className="pointer-events-none absolute inset-y-0 max-w-7xl mx-auto w-full min-w-[1280px]"
                >
                    {/* sm:left-1/2 sm:top-0 sm:translate-x-8 lg:left-1/2 lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-8 */}
                    <div className="absolute transform left-1/2">
                        <div className="  transform  relative h-64 w-full ">
                            {/* bg-gradient-to-r from-blue-400 via-purple-400 to-purple-500 */}
                            {/* <img src='/img/bg_gamedetail.png' /> */}
                        </div>
                        <div className="transform md:rounded-md  bg-white rotate-6 scale-110 translate-x-10 md:shadow-2xl -ml-4   -mt-52 p-4  space-y-2 ">
                            <AnimatePresence mode="wait">
                                <div className="px-4 sm:px-0 grid grid-cols-5 sm:grid-cols-4 gap-2 sm:gap-4 max-w-5xl mx-auto ">
                                    <BlurFade delay={0.00} inView><img src={enc("../img/Banner/2/组 31.webp")} /></BlurFade>
                                    <BlurFade delay={0.1} inView><img src={enc("../img/Banner/2/组 30.webp")} /></BlurFade>
                                    <BlurFade delay={0.2} inView><img src={enc("../img/Banner/2/组 29.webp")} /></BlurFade>
                                    <BlurFade delay={0.3} inView><img src={enc("../img/Banner/2/组 28.webp")} /></BlurFade>
                                    <BlurFade delay={0.00} inView><img src={enc("../img/Banner/2/组 27.webp")} /></BlurFade>
                                    <BlurFade delay={0.1} inView><img src={enc("../img/Banner/2/组 26.webp")} /></BlurFade>
                                    <BlurFade delay={0.2} inView><img src={enc("../img/Banner/2/组 25.webp")} /></BlurFade>
                                    <BlurFade delay={0.3} inView><img src={enc("../img/Banner/2/组 24.webp")} /></BlurFade>
                                    <BlurFade delay={0.00} inView><img src={enc("../img/Banner/2/组 23.webp")} /></BlurFade>
                                    <BlurFade delay={0.1} inView><img src={enc("../img/Banner/2/组 22.webp")} /></BlurFade>
                                    <BlurFade delay={0.2} inView><img src={enc("../img/Banner/2/组 21.webp")} /></BlurFade>
                                    <BlurFade delay={0.3} inView><img src={enc("../img/Banner/2/组 20.webp")} /></BlurFade>
                                </div>
                            </AnimatePresence>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const Section02 = () => {
    return (
        <>
            {/* style={{ display: "none" }} */}
            <div className="w-full  lg:absolute top-0 hidden lg:block right-0 bottom-0 mt-0 mr-4 overflow-hidden " id="screen2" >
                <div
                    aria-hidden="true"
                    className="pointer-events-none lg:absolute lg:inset-y-0 max-w-7xl mx-auto w-full "
                >
                    <div className="absolute transform sm:left-1/2 sm:top-0  lg:left-1/2  pt-4   lg:translate-x-8 overflow-hidden  w-full items-end">


                        <img tabIndex={0} src="../img/Banner/3/9.png " alt="" className='animate-myscale' />
                        {/* <AnimatePresence mode="wait">
                            <div className="px-4 flex flex-wrap items-end mt-4 ">
                                <div className="mt-24">
                                    <BlurFade delay={0.00} inView>
                                        <div className="flex items-end">
                                            <img tabIndex={0} src="../img/gameicon150/icon_game_hjkg.png" alt="girl with blue background" className="w-20 h-20 rounded-lg mr-6" />
                                            <img tabIndex={0} src="../img/gameicon150/点球_150.png" alt="guy winking" className="w-48 h-36 rounded-lg" />
                                        </div>
                                    </BlurFade>
                                    <BlurFade delay={0.1} inView>
                                        <div className="flex items-center justify-end my-6">
                                            <img tabIndex={0} src="../img/gameicon150/二人麻将_150.png" alt="guy smiling" />
                                        </div>
                                    </BlurFade>
                                    <BlurFade delay={0.2} inView>
                                        <div className="flex items-start">
                                            <img tabIndex={0} src="../img/gameicon150/大富翁.png" alt="girl with bluw background" className="w-48 h-48 rounded-lg" />
                                            <img tabIndex={0} src="../img/gameicon150/保卫公主_150.png" alt="guy with glasses" className="w-20 h-20 rounded-lg ml-6 flex-shrink-0 object-cover object-fit" />
                                        </div>
                                    </BlurFade>
                                </div>
                                <BlurFade delay={0.3} inView>
                                    <div className="ml-6 mt-32">
                                        <img tabIndex={0} src="../img/gameicon150/ludo_150.png" className="w-72 h-80 rounded-lg" alt="guy with sunglasses" />
                                        <div className="flex items-start mt-6">
                                            <img tabIndex={0} src="../img/gameicon150/二人斗地主_150.png" alt="girl  laughing" className="w-48 h-48 rounded-lg" />
                                            <img tabIndex={0} src="../img/gameicon150/domino_150.png" alt="guy with glasses" className="w-20 h-20 rounded-lg ml-6 object-cover object-fit" />
                                        </div>
                                    </div>
                                </BlurFade>
                                
                            </div>
                        </AnimatePresence> */}

                    </div>

                </div>
            </div>
        </>
    )
}


export default function BannerSection({ dict = homeDict.zh.banner }: { dict?: HomeBannerDict }) {
    const [current, setCurrent] = React.useState(0)
    const [currentScreen, setCurrentScreen] = React.useState(0)



    const [timer, setTimer] = useState<number>(0);
    useEffect(() => {
        const interval = setInterval(() => {
            setTimer((prev) => prev + 1);
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (timer > 5) {
            //setFeatureOpen((prev) => (prev + 1) % data.length);
            setCurrentScreen((currentScreen + 1) % 3)
            setTimer(0);
        }
    }, [timer]);



    function handleDotClick(dotindex: number) {

        //document.getElementById("screen0")!.style.display = "none";
        if (dotindex == 0) {
            setCurrentScreen(0)
            // document.getElementById("screen0")!.style.display = "";
            // document.getElementById("screen1")!.style.display = "none";
            // document.getElementById("screen2")!.style.display = "none";
        }
        else if (dotindex == 1) {
            setCurrentScreen(1)
            // document.getElementById("screen0")!.style.display = "none";
            // document.getElementById("screen1")!.style.display = "";
            // document.getElementById("screen2")!.style.display = "none";
        }
        else if (dotindex == 2) {
            setCurrentScreen(2)
            // document.getElementById("screen0")!.style.display = "none";
            // document.getElementById("screen1")!.style.display = "none";
            // document.getElementById("screen2")!.style.display = "";
        }


        //     document.getElementById("screen0")!.style.transform="-translate-y-500"
        //     document.getElementById("screen0")!.style.transitionDuration="1s"
        //     document.getElementById("screen0")!.style.transitionTimingFunction="ease"

        //    document.getElementById("screen1")!.style.display = "";
        //    //document.getElementById("screen0")!.style.transform="-translate-y-500"
        //     document.getElementById("screen0")!.style.transitionDuration="1s"
        //     document.getElementById("screen0")!.style.transitionTimingFunction="ease"
    }
    return (
        <>
            {/* lg 固定高度（640px）而非自适应：轮播切换文案/图墙时整块高度不变，彻底防抖动；右侧图墙本就 lg:absolute 不占布局 */}
            <div className="container mx-auto px-8 py-8 lg:py-0 lg:h-[640px] relative flex flex-col lg:flex-row items-center max-w-7xl min-w-[1280px]">
                <div className="lg:w-1/2 flex flex-col items-center lg:items-start z-10 ">
                    {/* <BlurFade delay={0.25} inView></BlurFade> */}
                    {/* <BoxReveal boxColor={"#5046e6"} duration={0.5}></BoxReveal> */}
                        {/* 固定最小高度：三屏文案长度不一，预留空间避免轮播切换时整页高度跳动 */}
                        <h1 className="tracking-tighter text-center lg:text-left text-3xl sm:text-5xl font-light text-blue-700 leading-tight mb-4 min-h-[8.5rem] sm:min-h-[11rem]">{dict.slides[currentScreen].title1}

                            <strong className="font-black text-3xl sm:text-3xl block pt-4">{dict.slides[currentScreen].title2}</strong>

                        </h1>
                    

                    {/* <BlurFade delay={0.45} inView></BlurFade> */}
                    <p className="text-center lg:text-left sm:text-lg text-gray-500 lg:pr-10 leading-relaxed pt-4 min-h-[3.5rem]">{dict.slides[currentScreen].title3}
                    </p>



                    {/* <BlurFade delay={0.55} inView></BlurFade> */}
                    {/* <a href="#" className="bg-blue-400 hover:bg-blue-500 mt-8 py-3 px-8 text-lg rounded-full font-bold uppercase text-white tracking-widest">Apply Now</a> */}
                    {/* 双 CTA：免费获取方案 → /contact2；查看全部游戏 → /gamelist2 */}
                    <div className="mt-12 flex flex-wrap items-center justify-center lg:justify-start gap-4">
                        <a href='../contact2' className="relative inline-flex rounded-full transition-transform duration-300 hover:-translate-y-0.5">
                            <p className="bg-blue-400 hover:bg-blue-500 py-4 px-12 text-2xl rounded-full font-bold text-white tracking-widest transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/30 ring-1 ring-blue-300/0 hover:ring-blue-200/60">{dict.ctaPrimary}</p>
                            {/* 光点沿按钮边缘缓慢游走（高级感） */}
                            <BorderBeam borderWidth={2} duration={5} color="#bfdbfe" />
                        </a>
                        <a href='../gamelist2' >
                            <p className="py-4 px-12 text-2xl rounded-full font-bold text-blue-700 tracking-widest ring-2 ring-blue-500/50 transition-all duration-300 hover:-translate-y-0.5 hover:bg-blue-50 hover:shadow-lg hover:shadow-blue-500/20">{dict.ctaSecondary}</p>
                        </a>
                    </div>





                    <BlurFade delay={0.85} inView>
                        <div className="mt-16 lg:mt-24 flex">
                            <button onClick={() => handleDotClick(0)} className={`block h-2 cursor-pointer rounded-2xl transition-all hover:scale-110 content-[''] ${currentScreen === 0 ? "w-12 bg-gradient-to-r from-green-600 via-blue-500 to-purple-600 " : "w-8 bg-black"
                                }`}
                            //style={{width:`${timer/5*100}%`}}
                            ></button>
                            <span onClick={() => handleDotClick(1)} className={`block h-2 ml-2 cursor-pointer rounded-2xl transition-all hover:scale-110 content-[''] ${currentScreen === 1 ? "w-12 bg-gradient-to-r from-green-600 via-blue-500 to-purple-600" : "w-8 bg-black"
                                }`}></span>
                            <span onClick={() => handleDotClick(2)} className={`block h-2 ml-2  cursor-pointer rounded-2xl transition-all hover:scale-110 content-[''] ${currentScreen === 2 ? "w-12 bg-gradient-to-r from-green-600 via-blue-500 to-purple-600" : "w-8 bg-black"
                                }`}></span>

                        </div>
                    </BlurFade>
                </div>

                {/* <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{
                      duration: 0.4,
                      scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },
                  }}
                >
                    </motion.div> */}

                {/* {( currentScreen == 0 ) => ( )} */}



                {/* 三屏全部保持挂载，仅切换显隐：避免条件渲染导致 <img> 反复重建、图片重复请求 */}
                <div className={currentScreen == 0 ? "contents" : "hidden"}>
                    <Section00 />
                </div>
                <div className={currentScreen == 1 ? "contents" : "hidden"}>
                    <Section01 />
                </div>
                <div className={currentScreen == 2 ? "contents" : "hidden"}>
                    <Section02 />
                </div>










                <div className="w-full  lg:absolute top-0 right-0 bottom-0 mt-0 mr-4 overflow-hidden " id="screen3" style={{ display: "none" }}>
                    <div
                        aria-hidden="true"
                        className="pointer-events-none lg:absolute lg:inset-y-0 max-w-7xl mx-auto w-full "
                    >
                        <div className="absolute transform sm:left-1/3 sm:top-0 sm:translate-x-8 lg:left-1/2 lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-8">
                            <div className="flex items-center space-x-6 lg:space-x-8 ">
                                <BannerSectionMarqueeVertical />
                            </div>
                        </div>
                    </div>
                </div>



            </div >

        </>
    )
}
